/**
 * @fileoverview A function that provides the batteries API.
 *
 * @example
 * const { result } = renderHook(() => useBatteriesAPI())
 */

import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from './utils/axiosBaseQuery'

/**
 * @function batteriesApi
 * @description Provides the batteries API.
 * @returns {ReturnType<typeof createApi>} - The batteries API.
 */
export const batteriesApi = createApi({
    reducerPath: 'batteriesApi',
    baseQuery: axiosBaseQuery({ baseUrl: `/private/batteries` }),
    endpoints: (builder) => ({
        getBatteries: builder.query<Novoic.API.Battery[], void>({
            query: () => {
                const sp = new URLSearchParams(location.search)
                return {
                    url: location.search ? `?${sp.toString()}` : '',
                    method: 'GET',
                }
            },
        }),

        getBatteriesByStudyId: builder.query<Novoic.API.Battery[], string>({
            query: (studyId: string) => {
                const sp = new URLSearchParams(location.search)
                sp.set('studies', studyId)
                return {
                    url: `?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),
    }),
})

export const { useGetBatteriesQuery, useGetBatteriesByStudyIdQuery } = batteriesApi
